<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ "cardOrders.title" | translate }}: {{ total }}</span>
    <div class="actions">
      <button mat-stroked-button type="button" (click)="loadOrders()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        {{ "cardOrders.refresh" | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" (click)="createOrder()">
        <mat-icon>add_shopping_cart</mat-icon>
        {{ "cardOrders.create" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="orders-wrapper">
    <form [formGroup]="filters" class="filters-row">
      <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          formControlName="search"
          [placeholder]="'printCardOrders.searchPlaceholder' | translate"
          [attr.aria-label]="'printCardOrders.search' | translate"
        />
      </mat-form-field>
    </form>

    <div
      class="table-container"
      [class.table-container--empty]="isEmpty || showNoSearchResults"
      [class.table-container--loading]="loading"
    >
      <mat-table
        [dataSource]="dataSource"
        class="orders-table mat-elevation-z0"
      >
        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.createdAt" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.createdAt | localizedDate : "short" }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="recipients">
          <mat-header-cell *matHeaderCellDef>{{ "cardOrders.recipients" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="table-cell-stack">
            <div class="employee-cell">
              <span class="employee-name" *ngIf="element.recipients?.length > 1">
                {{ "printCardOrders.groupRecipientsCount" | translate : { count: element.recipients.length } }}
              </span>
              <span class="employee-name" *ngIf="element.recipients?.length <= 1">
                {{ getOrderRecipientsSummary(element) }}
              </span>
              <span class="employee-email">
                {{ "cardOrders.placedBy" | translate }}: {{ element.placedByName || element.placedByEmail }}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="items">
          <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.items" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ orderItemsSummary(element) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>{{ "printCardOrders.status" | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="stage-badge" [attr.data-stage]="element.status">
              {{ getFulfillmentStageLabelKey(element.status) | translate }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="table-actions">
              @if (orderDetailLink(element); as link) {
                <a class="action-btn" [routerLink]="link" data-table-no-row-nav>
                  <mat-icon>visibility</mat-icon>
                  {{ "printCardOrders.details" | translate }}
                </a>
              }
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="orders-table__row"
          [appTableRowLink]="orderDetailLink(row)"
        ></mat-row>
      </mat-table>

      <div class="loading-wrapper" *ngIf="loading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!loading && isEmpty">
        <mat-icon class="empty-state__icon">shopping_bag</mat-icon>
        <p>{{ "cardOrders.empty" | translate }}</p>
        <button mat-raised-button color="primary" type="button" (click)="createOrder()">
          <mat-icon>add_shopping_cart</mat-icon>
          {{ "cardOrders.createFirst" | translate }}
        </button>
      </div>

      <div class="empty-state" *ngIf="showNoSearchResults">
        <mat-icon class="empty-state__icon">search_off</mat-icon>
        <p>{{ "printCardOrders.searchNoResults" | translate }}</p>
      </div>
    </div>

    <mat-paginator
      *ngIf="total > 0"
      [length]="total"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="changePage($event)"
    ></mat-paginator>
  </div>
</div>
